export const RedRectangle = () => {
  return (
    <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.99966 3.70522L18.9598 12.2136" stroke="#F75564" stroke-width="8" />
    </svg>
  );
};
